Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "noeventstext3669462797",
  {"root":"noeventstext3669462797--root","mobile":"noeventstext3669462797--mobile"},
  "",
  2,
  "noeventstext3669462797"
);

